package one.healthium.uscreen.domain.models

import kotlinx.serialization.Serializable

@Serializable
data class StyledTextModel(
    val segments: List<StyledSegment>,
) {
    @Serializable
    sealed interface StyledSegment {
        @Serializable
        data class Plain(val text: String) : StyledSegment

        @Serializable
        data class Styled(
            val text: String,
            val color: String? = null,
            val fontWeight: UScreenFontWeight? = null,
            val size: Int? = null,
            val strike: Boolean = false,
            val bg: String? = null,
        ) : StyledSegment
    }

    companion object {
        val preview = StyledTextModel(
            segments = listOf(
                StyledSegment.Plain("What is your "),
                StyledSegment.Styled(text = "main goal", fontWeight = UScreenFontWeight.Bold),
                StyledSegment.Plain("?"),
            ),
        )
    }
}
